import Axios from 'axios'
import config from '../../config'
import { InquiryTypes } from '../../constants/InquiryTypes'
import { transformDisponibility } from '../../utilities/dates'
import { InquiryPaths } from '../inquiries'
import { toInquiry, toPayment } from './adapters'

export const create = async ({
    type,
    address,
    description,
    disponibilities,
    invoicing,
    selected,
    duration,
    code,
    appliedCouponCodeId,
    leadFunnel,
    attribution
}) => {
  let URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths[type]}`
  let estimatedTime = null

  if (type === InquiryTypes.REALISATION) {
    estimatedTime = ((parseInt(duration.hours * 60, 10)) + duration.minutes) * 60
  }

  const response = await Axios.post(URL, {
    address,
    description,
    disponibilities: disponibilities
      .filter((d) => d.date && d.daytime)
      .map((d) => transformDisponibility(d.daytime, d.date)),
    invoicingAddress: invoicing,
    selected,
    zipCode: code,
    estimatedTime,
    appliedCouponCodeId,
    leadFunnel,
    attribution
  })
  return response.data
}

export const get = async ({ id, type }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths[type]}/${id}`
  const response = await Axios.get(URL)
  return toInquiry(type)(response.data)
}

export const cancel = async ({ id, proposal, reason, type }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths[type]}/${id}/${proposal}/cancel?reason=${reason}`
  await Axios.post(URL)
}

export const getPayment = async ({ id, proposal }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/realisations/${id}/pay/${proposal}`
  const response = await Axios.get(URL)
  return toPayment(response.data)
}

export const pay = async ({ id, proposal, type, mean, paymentType }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths[type]}/${id}/pay/${proposal}/${mean}`
  const { host, protocol, pathname } = window.location
  const body = {
    success: protocol + '//' + host + pathname + '?success',
    error: protocol + '//' + host + pathname + '?error',
    cancel: protocol + '//' + host + pathname + '?cancel',
    paymentType: paymentType
  }
  const response = await Axios.post(URL, body)
  if (response.data && response.data.redirect) {
    window.location.replace(response.data.redirect)
  }
}

export const close = async ({ type, id }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths[type]}/${id}/close`
  const response = await Axios.post(URL)
  return toInquiry(type)(response.data)
}



// WEBPACK FOOTER //
// ./src/api/inquiries/ponctual.js